import { Component, ViewChild, AfterViewInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/utils/shared.service';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import * as CommonConstants from '../../utils/common.constants';

@Component({
  selector: 'app-add-progress',
  templateUrl: './add-progress.component.html'
})
export class AddProgressComponent implements AfterViewInit {
  gridApi: GridApi;
  prList = [];
  rowData = [];
  status;
  @Input() medFileId;
  //add medication 
  colDefs;
  frameworkComponents;
  PARAM_KEY = [CommonConstants.STATUS];
  MED_PARAM_KEY = [CommonConstants.PROGRESS_MED_FILE];
  constructor(private modal: NgbModal, private masterService: MasterService, private sharedService: SharedService,
    private medFileService: MedicalFileService, private toastrService: ToastrService) {
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent
    }
  }

  ngOnInit() {
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medFileId = res;
    })
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        let masterValues = response['result'];
        this.status = masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
      }
    });
    this.loadProgress();
  }

  loadProgress() {
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medFileId = res;
      this.medFileService.getMedicalFilesByKey(this.medFileId, this.MED_PARAM_KEY).subscribe(response => {
        let masterValues = response['result'];
        if (masterValues) {
          this.prList = this.setProgressList(masterValues[CommonConstants.PROGRESS_MED_FILE]);
        }
      })
    })
  }

  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }

  ngAfterViewInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  openGridModal(modalId) {
    this.rowData = [];
    this.modal.open(modalId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.colDefs) {
      this.getGrids();
    }
  }

  addNewGridRow() {
    const newRow = {
      statuCode: '',
      hospType: '', medprDtDate: '', medprDtPrescription: '', medprNuDurationInDay: '', medmeNuQtyPerTake: '', medprVaName: '',
      medprVaOperator: '', description: ''
    };
    this.rowData.push(newRow);
    this.gridApi.setRowData(this.rowData);
  }

  getGrids() {
    this.colDefs = [
      { headerName: 'statuCode', field: 'statuCode', hide: true },
      { headerName: 'Date', field: 'date', cellEditor: 'agDateInput' },
      { headerName: 'Assesment', field: 'medtpVaAssesment' },
      { headerName: 'Objective', field: 'medtpVaObjective' },
      { headerName: 'Subjective', field: 'medtpVaSubjective' },
    /*   {
        headerName: 'Status', field: 'status', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
      }, */
    ];

  }


  onRowSelect(modelId) {
    this.getGrids();
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.rowData = this.prList;
  }


  saveProgress() {
    this.rowData = this.rowData.map(item => ({
      ...item,
      'medfiId': this.medFileId
    }));
    this.medFileService.saveProgress(this.rowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        if (res["result"][0])
          this.prList.push(this.setProgressList(res["result"][0]));
        this.prList = Object.values(this.prList.reduce((acc, c) => (acc[c.medtpId] = c, acc), {}));
        this.prList = [...this.prList];
        this.modal.dismissAll();
      }
    })
  }

  setProgressList(list) {
    if (Array.isArray(list)) {
      list = list.map(item => ({
        ...item,
        status: item.statuCode ? this.status.find(obj => +obj.id === +item.statuCode).value : null,
      }));
    } else {
      list = {
        ...list,
        status: list['statuCode'] ? this.status.find(obj => +obj.id === +list['statuCode']).value : null,
      }
    }
    return list;
  }
}